import React, { useContext, useEffect, useState } from 'react';
import { 
    Divider, Content, ContentVariants, Card, CardTitle, CardBody, CardFooter,
    Button, Grid, GridItem,
    Label, LabelGroup, Flex, FlexItem, LabelColor
} from '@patternfly/react-core';
import { Link } from "react-router-dom";
import { AuthContext, AppContext  } from 'shared/context';
import redhatLogoWhite from 'shared/assets/images/svg/linux/red-hat-logo-white-height-45px.svg';
import redhatLogoBlack from 'shared/assets/images/svg/linux/red-hat-logo-height-45px.svg';
import rockyLogoWhite from 'shared/assets/images/svg/linux/rocky-linux-white-height-45px.svg';
import rockyLogoBlack from 'shared/assets/images/svg/linux/rocky-linux-height-45px.svg';
import debianLogoWhite from 'shared/assets/images/svg/linux/debian-logo-white-height-45px.svg';
import debianLogoBlack from 'shared/assets/images/svg/linux/debian-logo-height-45px.svg';

const Head = () => {
    const [isDarkTheme, setIsDarkTheme] = useState(false);
    const authContext = useContext(AuthContext);
    const appContext = useContext(AppContext);

    const react_app_frontend_url = appContext.state.react_app_frontend_url;
    const org = appContext.state.organizationSymbol;
    const logon = `${react_app_frontend_url}/${org}/ti/auth`

    useEffect(() => {
        const updateTheme = () => {
            setIsDarkTheme(
                document.documentElement.classList.contains('pf-v6-theme-dark')
            );
        };

        updateTheme(); // natychmiast po mount

        const observer = new MutationObserver(updateTheme);

        observer.observe(document.documentElement, {
            attributes: true,
            attributeFilter: ['class']
        });

        return () => observer.disconnect();
    }, []);
    
    const RedHatLogo = isDarkTheme
        ? redhatLogoWhite
        : redhatLogoBlack;
    const RockyLogo = isDarkTheme
        ? rockyLogoWhite
        : rockyLogoBlack;
    const DebianLogo = isDarkTheme
        ? debianLogoWhite
        : debianLogoBlack;
    
    const Auth = () => {
        window.open(`${logon}`, '_self');
    }

    return (
        <>
        <Card variant="secondary" isLarge>
            <Grid>
                <GridItem
                    md={5}
                    style={{
                        minHeight: '200px',
                        backgroundPosition: 'center',
                        backgroundSize: 'cover',
                        // backgroundImage: 'url(https://raw.githubusercontent.com/patternfly/patternfly-react/main/packages/react-integration/demo-app-ts/src/assets/images/pfbg_992.jpg)'
                        backgroundImage: 'url(../../assets/images/pfbg_576.jpg)'
                    }}
                />
                <GridItem md={7}>
                    <CardTitle>
                        <Flex>
                            <FlexItem>
                                {/* <Content component={ContentVariants.h3}> */}
                                    <Label color={LabelColor.blue}><strong>Technik Informatyk</strong></Label> <Label color={LabelColor.blue}><strong>Technik Programista</strong></Label>
                                {/* </Content> */}
                            </FlexItem>
                            <FlexItem align={{ default: 'alignRight' }}>
                                {!authContext.state.isAuthUser
                                    ? (
                                        // <FlexItem>
                                        //     <Button onClick={Auth} variant="primary" size="sm">Zaloguj się</Button>
                                        // </FlexItem>
                                        <FlexItem>
                                            <Button
                                                variant="primary"
                                                size="sm"
                                                component={(props) => <Link {...props} to="/ckziu" />}
                                            >
                                                    Zobacz
                                            </Button>
                                        </FlexItem>
                                    )
                                    : (
                                        <FlexItem>
                                            <Button
                                                variant="secondary"
                                                size="sm"
                                                component={(props) => <Link {...props} to="/ckziu" />}
                                            >
                                                    Zobacz
                                            </Button>
                                        </FlexItem>
                                    )
                                }
                            </FlexItem>
                        </Flex>
                    </CardTitle>
                    <CardBody>
                        <Content component={ContentVariants.p}>
                            Uczniowie mogą rozwijać kompetencje w zakresie programowania, administracji systemami, konteneryzacji, wirtualizacji, automatyzacji i technologii chmurowych przy użyciu oVirt Virtualization, OpenShift Container Platform, Ceph Storage oraz Ansible Automation.
                        </Content>
                        <LabelGroup
                            numLabels={4}
                            collapsedText='${remaining} więcej'
                            expandedText='Pokaż mniej'
                            style={{ marginTop: '1rem' }}
                        >
                            <Label variant="outline">Arkusze egzaminacyjne</Label>
                            <Label variant="outline">Zbiory zadań</Label>
                            <Label variant="outline">Egzaminy próbne</Label>
                            <Label variant="outline">Analizy egzaminów</Label>
                            <Label variant="outline">oVirt Virtualization</Label>
                            <Label variant="outline">OpenShift Container Platform</Label>
                            <Label variant="outline">Ceph Storage</Label>
                            <Label variant="outline">Ansible Automation</Label>
                        </LabelGroup>
                        <Divider orientation={{ default: 'vertical' }} />
                    </CardBody>
                
                    <CardFooter>
                        <Flex>
                            <FlexItem>
                                <Flex
                                    spaceItems={{ default: 'spaceItemsLg' }}
                                    alignItems={{ default: 'alignItemsCenter' }}
                                >
                                    <Button 
                                        component="a"
                                        href="https://www.redhat.com"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        variant="plain"
                                    >
                                        <img
                                            src={RedHatLogo}
                                            alt="Red Hat"
                                            style={{
                                                height: '18px',
                                                position: 'relative',
                                                top: '2px'
                                            }}
                                        />
                                    </Button>
                                    <Divider orientation={{ default: 'vertical' }} />
                                    <Button
                                        component="a"
                                        href="https://rockylinux.org/pl-PL"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        variant="plain"
                                    >
                                        <img
                                            src={RockyLogo}
                                            alt="Rocky"
                                            style={{
                                                height: '18px',
                                                position: 'relative',
                                                top: '2px'
                                            }}
                                        />
                                    </Button>
                                    <Divider orientation={{ default: 'vertical' }} />
                                    <Button
                                        component="a"
                                        href="https://www.debian.org/"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        variant="plain"
                                    >
                                        <img
                                            src={DebianLogo}
                                            alt="Debian"
                                            style={{
                                                height: '22px',
                                                position: 'relative',
                                                top: '2px'
                                            }}
                                        />
                                    </Button>
                                </Flex>
                            </FlexItem>
                        </Flex>
                    </CardFooter>
                </GridItem>
            </Grid>
        </Card>
        </>
    );
};

export default Head;